import serviceCommon from './common';

const orderListUrl = '/saos-mids-api/orders'; // 订单列表
const cancelOrderUrl = '/saos-mids-api/orders/cancel/{orderId}'; // 取消订单
const userRightsUrl = '/saos-mids-api/user_rights/effective'; // 用户权益
const orderDetailUrl = '/mall-api/v2-0/orders'; // 订单详情-宋健

const checkStatusUrl = '/saos-mids-api/check_examine_status'; // 查询是否存在用户信息以及审核状态
const purchaseExamineUrl = '/saos-mids-api/user_info_purchase_examine'; // 提交保存用户审核信息
const commonInformationUrl = '/saos-mids-api/common_information'; // 通用信息
const vehicleCertificationUrl = '/saos-mids-api/vehicle_certifications'; // 整车认证信息

export default {
    // 订单列表
    async getOrderList() {
        const response = await serviceCommon.serviceAjax(orderListUrl, 'get', {
            pageNo: 0,
            pageSize: 999
        });
        return response && response.data;
    },
    // 查询是否存在用户信息以及审核状态
    async checkStatus() {
        const response = await serviceCommon.serviceAjax(checkStatusUrl, 'get');
        return response && response.data;
    },
    // 取消订单
    async cancelOrder(orderId: string) {
        const response = await serviceCommon.serviceAjax(
            cancelOrderUrl.replace('{orderId}', orderId),
            'post'
        );
        return response && response.data;
    },
    // 提交保存用户审核信息
    async purchse(data = {}) {
        const response = await serviceCommon.serviceAjax(
            purchaseExamineUrl,
            'post',
            data
        );
        return response;
    },
    // 用户权益
    async getUserRights(data = {}) {
        const response = await serviceCommon.serviceAjax(
            userRightsUrl,
            'get',
            data
        );
        return response && response.data;
    },
    // 获取订单详情
    async getOrderDetail(orderId: string, modules: string) {
        const response = await serviceCommon.serviceAjax(
            `${orderDetailUrl}/${orderId}`,
            'get',
            {
                modules
            }
        );
        return response.data;
    },
    // 查询通用信息
    async getCommonInformation() {
        const response = await serviceCommon.serviceAjax(
            commonInformationUrl,
            'get'
        );

        return response && response.data;
    },
    // 查询整车认证信息
    async getVehicleCertification() {
        const response = await serviceCommon.serviceAjax(
            vehicleCertificationUrl,
            'get'
        );

        return response && response.data;
    }
};
